export const apiEndpoint = "https://api.storex.io";

export const apiDevEndpoint = "https://api.storex.io:444";

export const defaultSession = { auth: { actor: "", permission: "" }, link: { walletType: "" } };

export const defaultAccount = { _id: "", fullName: "", email: { address: "" }, phone: { callingCode: "", phoneNumber: "" }, country: "", referral: "", registeredAddress: {}, billingAddress: [], deliveryAddress: [], notifications: [] };

export const kycStatus = { PASSED: "PASSED", PENDING: "PENDING", MANUAL_REVIEW: "MANUAL_REVIEW", UNSUBMITTED: "UNSUBMITTED", FAILED: "FAILED" };

export const defaultPK = "5KQwrPbwdL6PhXujxW37FSSQZ1JiwsST4cqQzDeyXtP79zkvFD3";

export const currencyDictionary = [
	{ name: "United States Dollar", code: "USD" },
	// { name: "Euro", code: "EUR" },
	// { name: "Great British Pound", code: "GBP" }
];

export const languageDictionary = [
	{ name: "English", code: "EN" },
	// { name: "Bulgarian", code: "BG" },
	// { name: "German", code: "DE" },
	// { name: "Spanish", code: "ES" },
	// { name: "French", code: "FR" },
	// { name: "Italian", code: "IT" },
	// { name: "Lithuanina", code: "LT" },
	// { name: "Mexican Spanish", code: "MX" },
	// { name: "Dutch", code: "NL" },
	// { name: "Norwegian", code: "NO" },
	// { name: "Filipino", code: "PH" },
	// { name: "Polish", code: "PL" },
	// { name: "Portuguese", code: "PT" },
	// { name: "Romanian", code: "RO" },
	// { name: "Serbian", code: "RS" },
	// { name: "Russian", code: "RU" },
	// { name: "Arabic", code: "SA" },
	// { name: "Swedish", code: "SE" },
	// { name: "Turkish", code: "TR" },
];

export const disputeReasonsBuyer = {
	"0": "Order has not arrived",
	"1": "Order not as described",
	"2": "Order arrived damaged",
	"3": "Refund has not been sent",
	"99": "Other reason"
};

export const disputeReasonsSeller = {
	"4": "Returned order not as described",
	"5": "Returned order arrived damaged",
	"99": "Other reason"
};

export const countryCodes = [{ "id": 0, "name": "Afghanistan", "callingCode": "93", "countryCode": "AF" }, { "id": 1, "name": "Åland Islands", "callingCode": "358", "countryCode": "AX" }, { "id": 2, "name": "Albania", "callingCode": "355", "countryCode": "AL" }, { "id": 3, "name": "Algeria", "callingCode": "213", "countryCode": "DZ" }, { "id": 4, "name": "American Samoa", "callingCode": "1684", "countryCode": "AS" }, { "id": 5, "name": "Andorra", "callingCode": "376", "countryCode": "AD" }, { "id": 6, "name": "Angola", "callingCode": "244", "countryCode": "AO" }, { "id": 7, "name": "Anguilla", "callingCode": "1264", "countryCode": "AI" }, { "id": 9, "name": "Antigua and Barbuda", "callingCode": "1268", "countryCode": "AG" }, { "id": 10, "name": "Argentina", "callingCode": "54", "countryCode": "AR" }, { "id": 11, "name": "Armenia", "callingCode": "374", "countryCode": "AM" }, { "id": 12, "name": "Aruba", "callingCode": "297", "countryCode": "AW" }, { "id": 13, "name": "Australia", "callingCode": "61", "countryCode": "AU" }, { "id": 14, "name": "Austria", "callingCode": "43", "countryCode": "AT" }, { "id": 15, "name": "Azerbaijan", "callingCode": "994", "countryCode": "AZ" }, { "id": 16, "name": "Bahamas", "callingCode": "1242", "countryCode": "BS" }, { "id": 17, "name": "Bahrain", "callingCode": "973", "countryCode": "BH" }, { "id": 18, "name": "Bangladesh", "callingCode": "880", "countryCode": "BD" }, { "id": 19, "name": "Barbados", "callingCode": "1246", "countryCode": "BB" }, { "id": 20, "name": "Belarus", "callingCode": "375", "countryCode": "BY" }, { "id": 21, "name": "Belgium", "callingCode": "32", "countryCode": "BE" }, { "id": 22, "name": "Belize", "callingCode": "501", "countryCode": "BZ" }, { "id": 23, "name": "Benin", "callingCode": "229", "countryCode": "BJ" }, { "id": 24, "name": "Bermuda", "callingCode": "1441", "countryCode": "BM" }, { "id": 25, "name": "Bhutan", "callingCode": "975", "countryCode": "BT" }, { "id": 26, "name": "Bolivia", "callingCode": "591", "countryCode": "BO" }, { "id": 27, "name": "Bonaire, Sint Eustatius and Saba", "callingCode": "5997", "countryCode": "BQ" }, { "id": 28, "name": "Bosnia and Herzegovina", "callingCode": "387", "countryCode": "BA" }, { "id": 29, "name": "Botswana", "callingCode": "267", "countryCode": "BW" }, { "id": 31, "name": "Brazil", "callingCode": "55", "countryCode": "BR" }, { "id": 32, "name": "British Indian Ocean Territory", "callingCode": "246", "countryCode": "IO" }, { "id": 33, "name": "Brunei", "callingCode": "673", "countryCode": "BN" }, { "id": 34, "name": "Bulgaria", "callingCode": "359", "countryCode": "BG" }, { "id": 35, "name": "Burkina Faso", "callingCode": "226", "countryCode": "BF" }, { "id": 36, "name": "Burundi", "callingCode": "257", "countryCode": "BI" }, { "id": 37, "name": "Cambodia", "callingCode": "855", "countryCode": "KH" }, { "id": 38, "name": "Cameroon", "callingCode": "237", "countryCode": "CM" }, { "id": 39, "name": "Canada", "callingCode": "1", "countryCode": "CA" }, { "id": 40, "name": "Cape Verde", "callingCode": "238", "countryCode": "CV" }, { "id": 41, "name": "Cayman Islands", "callingCode": "1345", "countryCode": "KY" }, { "id": 42, "name": "Central African Republic", "callingCode": "236", "countryCode": "CF" }, { "id": 43, "name": "Chad", "callingCode": "235", "countryCode": "TD" }, { "id": 44, "name": "Chile", "callingCode": "56", "countryCode": "CL" }, { "id": 45, "name": "China", "callingCode": "86", "countryCode": "CN" }, { "id": 46, "name": "Christmas Island", "callingCode": "61", "countryCode": "CX" }, { "id": 47, "name": "Cocos (Keeling) Islands", "callingCode": "61 891", "countryCode": "CC" }, { "id": 48, "name": "Colombia", "callingCode": "57", "countryCode": "CO" }, { "id": 49, "name": "Comoros", "callingCode": "269", "countryCode": "KM" }, { "id": 50, "name": "Congo", "callingCode": "242", "countryCode": "CG" }, { "id": 51, "name": "Cook Islands", "callingCode": "682", "countryCode": "CK" }, { "id": 52, "name": "Costa Rica", "callingCode": "506", "countryCode": "CR" }, { "id": 53, "name": "Croatia", "callingCode": "385", "countryCode": "HR" }, { "id": 54, "name": "Cuba", "callingCode": "53", "countryCode": "CU" }, { "id": 55, "name": "Curaçao", "callingCode": "599", "countryCode": "CW" }, { "id": 56, "name": "Cyprus", "callingCode": "357", "countryCode": "CY" }, { "id": 57, "name": "Czech Republic", "callingCode": "420", "countryCode": "CZ" }, { "id": 58, "name": "Democratic Republic of the Congo", "callingCode": "243", "countryCode": "CD" }, { "id": 59, "name": "Denmark", "callingCode": "45", "countryCode": "DK" }, { "id": 60, "name": "Djibouti", "callingCode": "253", "countryCode": "DJ" }, { "id": 61, "name": "Dominica", "callingCode": "767", "countryCode": "DM" }, { "id": 62, "name": "Dominican Republic", "callingCode": "1", "countryCode": "DO" }, { "id": 63, "name": "East Timor", "callingCode": "670", "countryCode": "TL" }, { "id": 64, "name": "Ecuador", "callingCode": "593", "countryCode": "EC" }, { "id": 65, "name": "Egypt", "callingCode": "20", "countryCode": "EG" }, { "id": 66, "name": "El Salvador", "callingCode": "503", "countryCode": "SV" }, { "id": 67, "name": "Equatorial Guinea", "callingCode": "240", "countryCode": "GQ" }, { "id": 68, "name": "Eritrea", "callingCode": "291", "countryCode": "ER" }, { "id": 69, "name": "Estonia", "callingCode": "372", "countryCode": "EE" }, { "id": 70, "name": "Eswatini", "callingCode": "268", "countryCode": "SZ" }, { "id": 71, "name": "Ethiopia", "callingCode": "251", "countryCode": "ET" }, { "id": 72, "name": "Falkland Islands", "callingCode": "500", "countryCode": "FK" }, { "id": 73, "name": "Faroe Islands", "callingCode": "298", "countryCode": "FO" }, { "id": 74, "name": "Fiji", "callingCode": "679", "countryCode": "FJ" }, { "id": 75, "name": "Finland", "callingCode": "358", "countryCode": "FI" }, { "id": 76, "name": "France", "callingCode": "33", "countryCode": "FR" }, { "id": 77, "name": "French Guiana", "callingCode": "594", "countryCode": "GF" }, { "id": 78, "name": "French Polynesia", "callingCode": "689", "countryCode": "PF" }, { "id": 79, "name": "French Southern and Antarctic Lands", "callingCode": "672", "countryCode": "TF" }, { "id": 80, "name": "Gabon", "callingCode": "241", "countryCode": "GA" }, { "id": 81, "name": "Gambia", "callingCode": "220", "countryCode": "GM" }, { "id": 82, "name": "Georgia", "callingCode": "995", "countryCode": "GE" }, { "id": 83, "name": "Germany", "callingCode": "49", "countryCode": "DE" }, { "id": 84, "name": "Ghana", "callingCode": "233", "countryCode": "GH" }, { "id": 85, "name": "Gibraltar", "callingCode": "350", "countryCode": "GI" }, { "id": 86, "name": "Greece", "callingCode": "30", "countryCode": "GR" }, { "id": 87, "name": "Greenland", "callingCode": "299", "countryCode": "GL" }, { "id": 88, "name": "Grenada", "callingCode": "1473", "countryCode": "GD" }, { "id": 89, "name": "Guadeloupe", "callingCode": "590", "countryCode": "GP" }, { "id": 90, "name": "Guam", "callingCode": "1", "countryCode": "GU" }, { "id": 91, "name": "Guatemala", "callingCode": "502", "countryCode": "GT" }, { "id": 92, "name": "Guernsey", "callingCode": "44", "countryCode": "GG" }, { "id": 93, "name": "Guinea", "callingCode": "224", "countryCode": "GN" }, { "id": 94, "name": "Guinea-Bissau", "callingCode": "245", "countryCode": "GW" }, { "id": 95, "name": "Guyana", "callingCode": "592", "countryCode": "GY" }, { "id": 96, "name": "Haiti", "callingCode": "509", "countryCode": "HT" }, { "id": 98, "name": "Holy See", "callingCode": "39", "countryCode": "VA" }, { "id": 99, "name": "Honduras", "callingCode": "504", "countryCode": "HN" }, { "id": 100, "name": "Hong Kong", "callingCode": "852", "countryCode": "HK" }, { "id": 101, "name": "Hungary", "callingCode": "36", "countryCode": "HU" }, { "id": 102, "name": "Iceland", "callingCode": "354", "countryCode": "IS" }, { "id": 103, "name": "India", "callingCode": "91", "countryCode": "IN" }, { "id": 104, "name": "Indonesia", "callingCode": "62", "countryCode": "ID" }, { "id": 105, "name": "Iran", "callingCode": "98", "countryCode": "IR" }, { "id": 106, "name": "Iraq", "callingCode": "964", "countryCode": "IQ" }, { "id": 107, "name": "Ireland", "callingCode": "353", "countryCode": "IE" }, { "id": 108, "name": "Isle of Man", "callingCode": "44", "countryCode": "IM" }, { "id": 109, "name": "Israel", "callingCode": "972", "countryCode": "IL" }, { "id": 110, "name": "Italy", "callingCode": "39", "countryCode": "IT" }, { "id": 111, "name": "Ivory Coast", "callingCode": "225", "countryCode": "CI" }, { "id": 112, "name": "Jamaica", "callingCode": "876", "countryCode": "JM" }, { "id": 113, "name": "Japan", "callingCode": "81", "countryCode": "JP" }, { "id": 114, "name": "Jersey", "callingCode": "44", "countryCode": "JE" }, { "id": 115, "name": "Jordan", "callingCode": "962", "countryCode": "JO" }, { "id": 116, "name": "Kazakhstan", "callingCode": "7", "countryCode": "KZ" }, { "id": 117, "name": "Kenya", "callingCode": "254", "countryCode": "KE" }, { "id": 118, "name": "Kiribati", "callingCode": "686", "countryCode": "KI" }, { "id": 119, "name": "Kuwait", "callingCode": "965", "countryCode": "KW" }, { "id": 120, "name": "Kyrgyzstan", "callingCode": "996", "countryCode": "KG" }, { "id": 121, "name": "Laos", "callingCode": "856", "countryCode": "LA" }, { "id": 122, "name": "Latvia", "callingCode": "371", "countryCode": "LV" }, { "id": 123, "name": "Lebanon", "callingCode": "961", "countryCode": "LB" }, { "id": 124, "name": "Lesotho", "callingCode": "266", "countryCode": "LS" }, { "id": 125, "name": "Liberia", "callingCode": "231", "countryCode": "LR" }, { "id": 126, "name": "Libya", "callingCode": "218", "countryCode": "LY" }, { "id": 127, "name": "Liechtenstein", "callingCode": "423", "countryCode": "LI" }, { "id": 128, "name": "Lithuania", "callingCode": "370", "countryCode": "LT" }, { "id": 129, "name": "Luxembourg", "callingCode": "352", "countryCode": "LU" }, { "id": 130, "name": "Macao", "callingCode": "853", "countryCode": "MO" }, { "id": 131, "name": "Madagascar", "callingCode": "261", "countryCode": "MG" }, { "id": 132, "name": "Malawi", "callingCode": "265", "countryCode": "MW" }, { "id": 133, "name": "Malaysia", "callingCode": "60", "countryCode": "MY" }, { "id": 134, "name": "Maldives", "callingCode": "960", "countryCode": "MV" }, { "id": 135, "name": "Mali", "callingCode": "223", "countryCode": "ML" }, { "id": 136, "name": "Malta", "callingCode": "356", "countryCode": "MT" }, { "id": 137, "name": "Marshall Islands", "callingCode": "692", "countryCode": "MH" }, { "id": 138, "name": "Martinique", "callingCode": "596", "countryCode": "MQ" }, { "id": 139, "name": "Mauritania", "callingCode": "222", "countryCode": "MR" }, { "id": 140, "name": "Mauritius", "callingCode": "230", "countryCode": "MU" }, { "id": 141, "name": "Mayotte", "callingCode": "262", "countryCode": "YT" }, { "id": 142, "name": "Mexico", "callingCode": "52", "countryCode": "MX" }, { "id": 144, "name": "Moldova", "callingCode": "373", "countryCode": "MD" }, { "id": 145, "name": "Monaco", "callingCode": "377", "countryCode": "MC" }, { "id": 146, "name": "Mongolia", "callingCode": "976", "countryCode": "MN" }, { "id": 147, "name": "Montenegro", "callingCode": "382", "countryCode": "ME" }, { "id": 148, "name": "Montserrat", "callingCode": "1664", "countryCode": "MS" }, { "id": 149, "name": "Morocco", "callingCode": "212", "countryCode": "MA" }, { "id": 150, "name": "Mozambique", "callingCode": "258", "countryCode": "MZ" }, { "id": 151, "name": "Myanmar", "callingCode": "95", "countryCode": "MM" }, { "id": 152, "name": "Namibia", "callingCode": "264", "countryCode": "NA" }, { "id": 153, "name": "Nauru", "callingCode": "674", "countryCode": "NR" }, { "id": 154, "name": "Nepal", "callingCode": "977", "countryCode": "NP" }, { "id": 155, "name": "Netherlands", "callingCode": "31", "countryCode": "NL" }, { "id": 156, "name": "New Caledonia", "callingCode": "687", "countryCode": "NC" }, { "id": 157, "name": "New Zealand", "callingCode": "64", "countryCode": "NZ" }, { "id": 158, "name": "Nicaragua", "callingCode": "505", "countryCode": "NI" }, { "id": 159, "name": "Niger", "callingCode": "227", "countryCode": "NE" }, { "id": 160, "name": "Nigeria", "callingCode": "234", "countryCode": "NG" }, { "id": 161, "name": "Niue", "callingCode": "683", "countryCode": "NU" }, { "id": 162, "name": "Norfolk Island", "callingCode": "672", "countryCode": "NF" }, { "id": 163, "name": "North Korea", "callingCode": "850", "countryCode": "KP" }, { "id": 164, "name": "North Macedonia", "callingCode": "389", "countryCode": "MK" }, { "id": 165, "name": "Northern Mariana Islands", "callingCode": "1670", "countryCode": "MP" }, { "id": 166, "name": "Norway", "callingCode": "47", "countryCode": "NO" }, { "id": 167, "name": "Oman", "callingCode": "968", "countryCode": "OM" }, { "id": 168, "name": "Pakistan", "callingCode": "92", "countryCode": "PK" }, { "id": 169, "name": "Palau", "callingCode": "680", "countryCode": "PW" }, { "id": 170, "name": "Palestine", "callingCode": "970", "countryCode": "PS" }, { "id": 171, "name": "Panama", "callingCode": "507", "countryCode": "PA" }, { "id": 172, "name": "Papua New Guinea", "callingCode": "675", "countryCode": "PG" }, { "id": 173, "name": "Paraguay", "callingCode": "595", "countryCode": "PY" }, { "id": 174, "name": "Peru", "callingCode": "51", "countryCode": "PE" }, { "id": 175, "name": "Philippines", "callingCode": "63", "countryCode": "PH" }, { "id": 176, "name": "Pitcairn Islands", "callingCode": "64", "countryCode": "PN" }, { "id": 177, "name": "Poland", "callingCode": "48", "countryCode": "PL" }, { "id": 178, "name": "Portugal", "callingCode": "351", "countryCode": "PT" }, { "id": 179, "name": "Puerto Rico", "callingCode": "1", "countryCode": "PR" }, { "id": 180, "name": "Qatar", "callingCode": "974", "countryCode": "QA" }, { "id": 181, "name": "Romania", "callingCode": "40", "countryCode": "RO" }, { "id": 182, "name": "Russia", "callingCode": "7", "countryCode": "RU" }, { "id": 183, "name": "Rwanda", "callingCode": "250", "countryCode": "RW" }, { "id": 184, "name": "Réunion", "callingCode": "262", "countryCode": "RE" }, { "id": 185, "name": "Saint Barthélemy", "callingCode": "590", "countryCode": "BL" }, { "id": 186, "name": "Saint Helena, Ascension and Tristan da Cunha", "callingCode": "290", "countryCode": "SH" }, { "id": 187, "name": "Saint Kitts and Nevis", "callingCode": "1869", "countryCode": "KN" }, { "id": 188, "name": "Saint Lucia", "callingCode": "1758", "countryCode": "LC" }, { "id": 189, "name": "Saint Martin (French)", "callingCode": "590", "countryCode": "MF" }, { "id": 190, "name": "Saint Pierre and Miquelon", "callingCode": "508", "countryCode": "PM" }, { "id": 191, "name": "Saint Vincent and the Grenadines", "callingCode": "1784", "countryCode": "VC" }, { "id": 192, "name": "Samoa", "callingCode": "685", "countryCode": "WS" }, { "id": 193, "name": "San Marino", "callingCode": "378", "countryCode": "SM" }, { "id": 194, "name": "São Tomé and Príncipe", "callingCode": "239", "countryCode": "ST" }, { "id": 195, "name": "Saudi Arabia", "callingCode": "966", "countryCode": "SA" }, { "id": 196, "name": "Senegal", "callingCode": "221", "countryCode": "SN" }, { "id": 197, "name": "Serbia", "callingCode": "381", "countryCode": "RS" }, { "id": 198, "name": "Seychelles", "callingCode": "248", "countryCode": "SC" }, { "id": 199, "name": "Sierra Leone", "callingCode": "232", "countryCode": "SL" }, { "id": 200, "name": "Singapore", "callingCode": "65", "countryCode": "SG" }, { "id": 201, "name": "Sint Maarten (Dutch)", "callingCode": "1721", "countryCode": "SX" }, { "id": 202, "name": "Slovakia", "callingCode": "421", "countryCode": "SK" }, { "id": 203, "name": "Slovenia", "callingCode": "386", "countryCode": "SI" }, { "id": 204, "name": "Solomon Islands", "callingCode": "677", "countryCode": "SB" }, { "id": 205, "name": "Somalia", "callingCode": "252", "countryCode": "SO" }, { "id": 206, "name": "South Africa", "callingCode": "27", "countryCode": "ZA" }, { "id": 207, "name": "South Georgia and the South Sandwich Islands", "callingCode": "500", "countryCode": "GS" }, { "id": 208, "name": "South Korea", "callingCode": "82", "countryCode": "KR" }, { "id": 209, "name": "South Sudan", "callingCode": "211", "countryCode": "SS" }, { "id": 210, "name": "Spain", "callingCode": "34", "countryCode": "ES" }, { "id": 211, "name": "Sri Lanka", "callingCode": "94", "countryCode": "LK" }, { "id": 212, "name": "Sudan", "callingCode": "249", "countryCode": "SD" }, { "id": 213, "name": "Suriname", "callingCode": "597", "countryCode": "SR" }, { "id": 214, "name": "Svalbard and Jan Mayen", "callingCode": "4779", "countryCode": "SJ" }, { "id": 215, "name": "Sweden", "callingCode": "46", "countryCode": "SE" }, { "id": 216, "name": "Switzerland", "callingCode": "41", "countryCode": "CH" }, { "id": 217, "name": "Syria", "callingCode": "963", "countryCode": "SY" }, { "id": 218, "name": "Taiwan", "callingCode": "886", "countryCode": "TW" }, { "id": 219, "name": "Tajikistan", "callingCode": "992", "countryCode": "TJ" }, { "id": 220, "name": "Tanzania", "callingCode": "255", "countryCode": "TZ" }, { "id": 221, "name": "Thailand", "callingCode": "66", "countryCode": "TH" }, { "id": 222, "name": "Togo", "callingCode": "228", "countryCode": "TG" }, { "id": 223, "name": "Tokelau", "callingCode": "690", "countryCode": "TK" }, { "id": 224, "name": "Tonga", "callingCode": "676", "countryCode": "TO" }, { "id": 225, "name": "Trinidad and Tobago", "callingCode": "868", "countryCode": "TT" }, { "id": 226, "name": "Tunisia", "callingCode": "216", "countryCode": "TN" }, { "id": 227, "name": "Turkey", "callingCode": "90", "countryCode": "TR" }, { "id": 228, "name": "Turkmenistan", "callingCode": "993", "countryCode": "TM" }, { "id": 229, "name": "Turks and Caicos Islands", "callingCode": "1649", "countryCode": "TC" }, { "id": 230, "name": "Tuvalu", "callingCode": "688", "countryCode": "TV" }, { "id": 231, "name": "Uganda", "callingCode": "256", "countryCode": "UG" }, { "id": 232, "name": "Ukraine", "callingCode": "380", "countryCode": "UA" }, { "id": 233, "name": "United Arab Emirates", "callingCode": "971", "countryCode": "AE" }, { "id": 234, "name": "United Kingdom", "callingCode": "44", "countryCode": "GB" }, { "id": 236, "name": "United States of America", "callingCode": "1", "countryCode": "US" }, { "id": 237, "name": "Uruguay", "callingCode": "598", "countryCode": "UY" }, { "id": 238, "name": "Uzbekistan", "callingCode": "998", "countryCode": "UZ" }, { "id": 239, "name": "Vanuatu", "callingCode": "678", "countryCode": "VU" }, { "id": 240, "name": "Venezuela", "callingCode": "58", "countryCode": "VE" }, { "id": 241, "name": "Vietnam", "callingCode": "84", "countryCode": "VN" }, { "id": 242, "name": "Virgin Islands (British)", "callingCode": "1284", "countryCode": "VG" }, { "id": 243, "name": "Virgin Islands (U.S.)", "callingCode": "1340", "countryCode": "VI" }, { "id": 244, "name": "Wallis and Futuna", "callingCode": "681", "countryCode": "WF" }, { "id": 245, "name": "Western Sahara", "callingCode": "212", "countryCode": "EH" }, { "id": 246, "name": "Yemen", "callingCode": "967", "countryCode": "YE" }, { "id": 247, "name": "Zambia", "callingCode": "260", "countryCode": "ZM" }, { "id": 248, "name": "Zimbabwe", "callingCode": "263", "countryCode": "ZW" }];

export const countryCodesDictionary = { "AF": "Afghanistan", "AX": "Åland Islands", "AL": "Albania", "DZ": "Algeria", "AS": "American Samoa", "AD": "Andorra", "AO": "Angola", "AI": "Anguilla", "AG": "Antigua and Barbuda", "AR": "Argentina", "AM": "Armenia", "AW": "Aruba", "AU": "Australia", "AT": "Austria", "AZ": "Azerbaijan", "BS": "Bahamas", "BH": "Bahrain", "BD": "Bangladesh", "BB": "Barbados", "BY": "Belarus", "BE": "Belgium", "BZ": "Belize", "BJ": "Benin", "BM": "Bermuda", "BT": "Bhutan", "BO": "Bolivia", "BQ": "Bonaire, Sint Eustatius and Saba", "BA": "Bosnia and Herzegovina", "BW": "Botswana", "BR": "Brazil", "IO": "British Indian Ocean Territory", "BN": "Brunei", "BG": "Bulgaria", "BF": "Burkina Faso", "BI": "Burundi", "KH": "Cambodia", "CM": "Cameroon", "CA": "Canada", "CV": "Cape Verde", "KY": "Cayman Islands", "CF": "Central African Republic", "TD": "Chad", "CL": "Chile", "CN": "China", "CX": "Christmas Island", "CC": "Cocos (Keeling) Islands", "CO": "Colombia", "KM": "Comoros", "CG": "Congo", "CK": "Cook Islands", "CR": "Costa Rica", "HR": "Croatia", "CU": "Cuba", "CW": "Curaçao", "CY": "Cyprus", "CZ": "Czech Republic", "CD": "Democratic Republic of the Congo", "DK": "Denmark", "DJ": "Djibouti", "DM": "Dominica", "DO": "Dominican Republic", "TL": "East Timor", "EC": "Ecuador", "EG": "Egypt", "SV": "El Salvador", "GQ": "Equatorial Guinea", "ER": "Eritrea", "EE": "Estonia", "SZ": "Eswatini", "ET": "Ethiopia", "FK": "Falkland Islands", "FO": "Faroe Islands", "FJ": "Fiji", "FI": "Finland", "FR": "France", "GF": "French Guiana", "PF": "French Polynesia", "TF": "French Southern and Antarctic Lands", "GA": "Gabon", "GM": "Gambia", "GE": "Georgia", "DE": "Germany", "GH": "Ghana", "GI": "Gibraltar", "GR": "Greece", "GL": "Greenland", "GD": "Grenada", "GP": "Guadeloupe", "GU": "Guam", "GT": "Guatemala", "GG": "Guernsey", "GN": "Guinea", "GW": "Guinea-Bissau", "GY": "Guyana", "HT": "Haiti", "VA": "Holy See", "HN": "Honduras", "HK": "Hong Kong", "HU": "Hungary", "IS": "Iceland", "IN": "India", "ID": "Indonesia", "IR": "Iran", "IQ": "Iraq", "IE": "Ireland", "IM": "Isle of Man", "IL": "Israel", "IT": "Italy", "CI": "Ivory Coast", "JM": "Jamaica", "JP": "Japan", "JE": "Jersey", "JO": "Jordan", "KZ": "Kazakhstan", "KE": "Kenya", "KI": "Kiribati", "XK": "Kosovo", "KW": "Kuwait", "KG": "Kyrgyzstan", "LA": "Laos", "LV": "Latvia", "LB": "Lebanon", "LS": "Lesotho", "LR": "Liberia", "LY": "Libya", "LI": "Liechtenstein", "LT": "Lithuania", "LU": "Luxembourg", "MO": "Macao", "MG": "Madagascar", "MW": "Malawi", "MY": "Malaysia", "MV": "Maldives", "ML": "Mali", "MT": "Malta", "MH": "Marshall Islands", "MQ": "Martinique", "MR": "Mauritania", "MU": "Mauritius", "YT": "Mayotte", "MX": "Mexico", "MD": "Moldova", "MC": "Monaco", "MN": "Mongolia", "ME": "Montenegro", "MS": "Montserrat", "MA": "Morocco", "MZ": "Mozambique", "MM": "Myanmar", "NA": "Namibia", "NR": "Nauru", "NP": "Nepal", "NL": "Netherlands", "NC": "New Caledonia", "NZ": "New Zealand", "NI": "Nicaragua", "NE": "Niger", "NG": "Nigeria", "NU": "Niue", "NF": "Norfolk Island", "KP": "North Korea", "MK": "North Macedonia", "MP": "Northern Mariana Islands", "NO": "Norway", "OM": "Oman", "PK": "Pakistan", "PW": "Palau", "PS": "Palestine", "PA": "Panama", "PG": "Papua New Guinea", "PY": "Paraguay", "PE": "Peru", "PH": "Philippines", "PN": "Pitcairn Islands", "PL": "Poland", "PT": "Portugal", "PR": "Puerto Rico", "QA": "Qatar", "RO": "Romania", "RU": "Russia", "RW": "Rwanda", "RE": "Réunion", "BL": "Saint Barthélemy", "SH": "Saint Helena, Ascension and Tristan da Cunha", "KN": "Saint Kitts and Nevis", "LC": "Saint Lucia", "MF": "Saint Martin (French)", "PM": "Saint Pierre and Miquelon", "VC": "Saint Vincent and the Grenadines", "WS": "Samoa", "SM": "San Marino", "ST": "São Tomé and Príncipe", "SA": "Saudi Arabia", "SN": "Senegal", "RS": "Serbia", "SC": "Seychelles", "SL": "Sierra Leone", "SG": "Singapore", "SX": "Sint Maarten (Dutch)", "SK": "Slovakia", "SI": "Slovenia", "SB": "Solomon Islands", "SO": "Somalia", "ZA": "South Africa", "GS": "South Georgia and the South Sandwich Islands", "KR": "South Korea", "SS": "South Sudan", "ES": "Spain", "LK": "Sri Lanka", "SD": "Sudan", "SR": "Suriname", "SJ": "Svalbard and Jan Mayen", "SE": "Sweden", "CH": "Switzerland", "SY": "Syria", "TW": "Taiwan", "TJ": "Tajikistan", "TZ": "Tanzania", "TH": "Thailand", "TG": "Togo", "TK": "Tokelau", "TO": "Tonga", "TT": "Trinidad and Tobago", "TN": "Tunisia", "TR": "Turkey", "TM": "Turkmenistan", "TC": "Turks and Caicos Islands", "TV": "Tuvalu", "UG": "Uganda", "UA": "Ukraine", "AE": "United Arab Emirates", "GB": "United Kingdom", "GB-N": "United Kingdom (Northern Ireland)", "US": "United States of America", "UY": "Uruguay", "UZ": "Uzbekistan", "VU": "Vanuatu", "VE": "Venezuela", "VN": "Vietnam", "VG": "Virgin Islands (British)", "VI": "Virgin Islands (U.S.)", "WF": "Wallis and Futuna", "EH": "Western Sahara", "YE": "Yemen", "ZM": "Zambia", "ZW": "Zimbabwe" };

export const regionCodesDictionary = { "USA": ["US"], "UK": ["GB", "GG", "IM", "JE"], "EUR": ["AX", "VA", "SJ", "IE", "DE", "DK", "FR", "MC", "AT", "BE", "BG", "HR", "CY", "CZ", "EE", "FI", "GR", "HU", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE", "AL", "AD", "AM", "AZ", "BY", "BA", "FO", "GE", "GI", "GL", "IS", "KZ", "XK", "KG", "LI", "MD", "ME", "MK", "NO", "RU", "SM", "RS", "CH", "TJ", "TR", "TM", "UA", "UZ"], "WZ1": ["BQ", "CD", "GP", "MQ", "YT", "MN", "BL", "MF", "SX", "TW", "EH", "AF", "DZ", "AO", "AI", "AG", "AR", "AW", "BS", "BH", "BD", "BB", "BZ", "BJ", "BM", "BT", "BO", "BW", "BR", "BN", "BF", "BI", "KH", "CM", "CA", "KY", "CV", "CF", "TD", "CL", "CN", "CO", "KM", "CG", "CR", "CU", "CW", "DJ", "DM", "DO", "TL", "EC", "EG", "SV", "GQ", "ER", "SZ", "ET", "FK", "GF", "GA", "GM", "GH", "GD", "GU", "GT", "GN", "GW", "GY", "HT", "HN", "HK", "IN", "ID", "IR", "IQ", "IL", "CI", "JM", "JP", "JO", "KE", "KW", "LB", "LS", "LR", "LY", "MG", "MW", "MY", "MV", "ML", "MH", "MR", "MU", "MX", "MS", "MA", "MZ", "MM", "NA", "NP", "NI", "NE", "NG", "MP", "KP", "OM", "PK", "PS", "PA", "PY", "PE", "PH", "PR", "QA", "RE", "RW", "SH", "KN", "LC", "PM", "VC", "ST", "SA", "SN", "SC", "SL", "SO", "ZA", "GS", "KR", "SS", "LK", "SD", "SR", "SY", "TZ", "TH", "TG", "TT", "TN", "TC", "UG", "AE", "UY", "VU", "VE", "VN", "VG", "VI", "WF", "YE", "ZM", "ZW"], "WZ2": ["AU", "PW", "IO", "CX", "CC", "CK", "FJ", "PF", "TF", "KI", "MO", "NR", "NC", "NZ", "NU", "NF", "PG", "LA", "PN", "SG", "SB", "TK", "TO", "TV", "AS", "WS"] };

export const regionDictionary = { "Northern Ireland": "GB-N" };

export const maxMessageLength = 500;

export const maxTitleLength = 100;

export const maxDescriptionLength = 2000;

export const maxTagsLength = 5;

export const maxTagNameLength = 30;

export const acceptedImageTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp", "application/pdf"];

export const maxImagesLength = 12;

export const maxImagesSize = 8000000;

export const maxOptionLength = 3;

export const maxActiveListings = 100;

export const maxReviewCommentsLength = 100;

export const filterPriceIntervals = [[0.01, 9.99], [10, 49.99], [50, 99.99], [100, 199.99], [200, 499.99], [500, 999.99], [1000]];

export const filterConditions = ["New", "Opened - Never Used", "Used", "Refurbished", "Not Working - Parts or Repair"];

export const filterStock = ["In Stock", "Out of Stock"];

export const filterCurrencies = ["STRX", "XPR", "BTC", "ETH", "DOGE", "METAL", "LOAN", "USDC", "USDT", "XMD", "SNIPS", "EUROC", "FOOBAR"];

export const filterSellerKYC = ["Yes", "No"];

export const filterBuyerKYC = ["Yes", "No"];

export const filterShips = ["Yes", "No"];

export const supportedCurrencies = [
	{ name: "STRX", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/strx.png", ticker: "STRX", contract: "storex", precision: 4, feedIndex: 0, chains: { "XPR Network": "", "Solana": "SPL" }, networks: { "Solana": "SPL" }, fireblocks: true, trade: [ "alcor" ], farm: 102 },
	{ name: "XPR", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/xpr2.png", ticker: "XPR", contract: "eosio.token", precision: 4, feedIndex: 3, chains: { "XPR Network": "", "Ethereum": "ERC20", "Binance (BEP20)": "BEP20" }, networks: { "Ethereum": "erc20", "Binance (BEP20)": "bep20" }, trade: [ "alcor", "metalx" ], faucet: 1, bp: true },
	{ name: "BTC", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/xbtc.png", ticker: "XBTC", contract: "xtokens", precision: 8, feedIndex: 4, chains: { "XPR Network": "", "Bitcoin": "" }, networks: { "Bitcoin": "mainnet" }, trade: [ "alcor", "metalx" ] },
	{ name: "ETH", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/xeth.png", ticker: "XETH", contract: "xtokens", precision: 8, feedIndex: 7, chains: { "XPR Network": "", "Ethereum": "" }, networks: { "Ethereum": "mainnet" }, trade: [ "alcor", "metalx" ] },
	{ name: "DOGE", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/xdoge.png", ticker: "XDOGE", contract: "xtokens", precision: 6, feedIndex: 8, chains: { "XPR Network": "", "Dogecoin": "" }, networks: { "Dogecoin": "mainnet" }, trade: [ "alcor", "metalx" ] },
	{ name: "METAL", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/metal-chain.png", ticker: "METAL", contract: "xtokens", precision: 8, feedIndex: 0, chains: { "XPR Network": "", "Metal C-Chain": "", "Ethereum": "?Ethereum" }, networks: { "Metal C-Chain": "evm", "Ethereum": "erc20" }, trade: [ "alcor", "metalx" ] },
	{ name: "LOAN", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/loan.png", ticker: "LOAN", contract: "loan.token", precision: 4, feedIndex: 0, chains: { "XPR Network": "" }, trade: [ "alcor", "metalx" ], faucet: 3 },
	{ name: "USDC", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/usdc.png", ticker: "XUSDC", contract: "xtokens", precision: 6, feedIndex: 5, chains: { "XPR Network": "", "Ethereum": "", "Stellar": "XLM" }, networks: { "Ethereum": "erc20", "Stellar": "xlm" }, trade: [ "alcor", "metalx" ], faucet: 4 },
	{ name: "USDT", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/xusdt.png", ticker: "XUSDT", contract: "xtokens", precision: 6, feedIndex: 9, chains: { "XPR Network": "", "Ethereum": "" }, networks: { "Ethereum": "erc20" }, trade: [ "alcor", "metalx" ] },
	{ name: "XMD", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/xmd.png", ticker: "XMD", contract: "xmd.token", precision: 6, feedIndex: 12, chains: { "XPR Network": "" }, trade: [ "alcor", "metalx" ] },
	{ name: "SNIPS", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/snips.png", ticker: "SNIPS", contract: "snipcoins", precision: 4, feedIndex: 0, chains: { "XPR Network": "" }, trade: [ "alcor", "metalx" ] },
	{ name: "DANK", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://i.ibb.co/HHjH1fh/Untitled-design-97.png", ticker: "DANK", contract: "electronteam", precision: 2, feedIndex: 0, chains: { "XPR Network": "" }, trade: [ "alcor" ] },
	{ name: "CLAN", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://i.imgur.com/2yzMIfT.png", ticker: "CLAN", contract: "clanx", precision: 4, feedIndex: 0, chains: { "XPR Network": "" }, trade: [ "alcor" ], /*farm: 16*/ },
	{ name: "BEGGARS", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://i.imgur.com/fyTLj40.png", ticker: "BEGGARS", contract: "beggars", precision: 4, feedIndex: 0, chains: { "XPR Network": "" }, trade: [ "alcor" ] },
	{ name: "BLPAD", logo: "https://bloks.io/cdn-cgi/image/width=70,height=70/https://blastpad.io/token.png", ticker: "BLPAD", contract: "tokencreate", precision: 6, feedIndex: 0, chains: { "XPR Network": "" }, trade: [ "alcor" ] },
	{ name: "CTRAVL", logo: "https://bloks.io/cdn-cgi/image/width=70,height=70/https://blastpad.io/uploads/token_create/1707955945_travel_token_logo-circle.png", ticker: "CTRAVL", contract: "tokencreate", precision: 4, feedIndex: 0, chains: { "XPR Network": "", "Solana": "SPL", "BNB Smart Chain": "BEP20", "Base": "ERC20-BASE", "Optimism": "ERC20-OP" }, networks: { "Solana": "SPL", "BNB Smart Chain": "BEP20", "Base": "ERC20-BASE", "Optimism": "ERC20-OP" }, fireblocks: true, trade: [ "alcor" ] },
	{ name: "EASY", logo: "https://raw.githubusercontent.com/alcorexchange/alcor-ui/refs/heads/master/assets/tokens/proton/easy_mon3y.png", ticker: "EASY", contract: "mon3y", precision: 6, feedIndex: 0, chains: { "XPR Network": "", "Solana": "SPL", "BNB Smart Chain": "BEP20", "Base": "ERC20-BASE", "Optimism": "ERC20-OP" }, networks: { "Solana": "SPL", "BNB Smart Chain": "BEP20", "Base": "ERC20-BASE", "Optimism": "ERC20-OP" }, fireblocks: true, trade: [ "alcor" ], tax: 2, disableFireblocksSend: true, disableFireblocksReceive: false }
];

export const defaultGenCoin = {
	"Ethereum": "XPR-ERC20",
	"Binance (BEP20)": "XPR-BEP20"
};

export const networkMemos = {
	"Stellar": true
};

export const fireblocksAssets = {
	"STRX_B75VRLGX_82H5": {
		chain: "Ethereum"
	},
	"STRX_B6FMGL4Y_LSDX": {
		chain: "Binance (BEP20)"
	},
	"SOLBAY_B7ZDHS8D_YDLJ": {
		chain: "Solana"
	}
};

export const stakingTiers = {
	20000000: { tier: 5, name: "Whale", colour: "#0f52ba", discount: 5, emoji: "🐋" },
	10000000: { tier: 4, name: "Shark", colour: "#33ccff", discount: 4, emoji: "🦈" },
	5000000: { tier: 3, name: "Dolphin", colour: "#ffd700", discount: 3, emoji: "🐬" },
	1000000: { tier: 2, name: "Fish", colour: "#d7d7d7", discount: 2, emoji: "🐟" },
	500000: { tier: 1, name: "Shrimp", colour: "#ad8a56", discount: 1, emoji: "🦐" },
	0: { tier: 0, name: "Free", colour: "#eeeeee", discount: 0, emoji: "🙏" }
};

export const defaultVouchers = {
	1: { ticker: "STRX", price: 5, name: "$5 Gift Voucher (STRX)", color: "#805fd3", logo: "https://bloks.io/cdn-cgi/image/width=170,height=170/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/strx.png" },
	2: { ticker: "STRX", price: 10, name: "$10 Gift Voucher (STRX)", color: "#805fd3", logo: "https://bloks.io/cdn-cgi/image/width=170,height=170/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/strx.png" },
	3: { ticker: "STRX", price: 25, name: "$25 Gift Voucher (STRX)", color: "#805fd3", logo: "https://bloks.io/cdn-cgi/image/width=170,height=170/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/strx.png" },
	4: { ticker: "STRX", price: 50, name: "$50 Gift Voucher (STRX)", color: "#805fd3", logo: "https://bloks.io/cdn-cgi/image/width=170,height=170/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/strx.png" },
	5: { ticker: "STRX", price: 100, name: "$100 Gift Voucher (STRX)", color: "#805fd3", logo: "https://bloks.io/cdn-cgi/image/width=170,height=170/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/strx.png" }
};

export const notificationTemplates = {
	message: {
		icon: "fal fa-envelope",
		title: "New Message",
		text: "You have received a new message from [username]",
		action: {
			text: "View Message",
			link: "/messages/[username]"
		},
		color: "green"
	},
	soldItem: {
		icon: "fal fa-tag",
		title: "Sold Item",
		text: "You have sold listing #[listingId] to [username]",
		action: {
			text: "View Order Details",
			link: "/account/sales"
		},
		color: "green"
	},
	itemShipped: {
		icon: "fal fa-truck-loading",
		title: "Item Shipped",
		text: "Order #[orderId] has been marked as shipped",
		action: {
			text: "View Order Details",
			link: "/account/orders"
		},
		color: "green"
	},
	refundReceived: {
		icon: "fal fa-hand-holding-usd",
		title: "Refund Received",
		text: "You were refunded $[refundAmount] for order #[orderId]",
		action: {
			text: "View Order Details",
			link: "/account/orders"
		},
		color: "amber"
	},
	escrowExtended: {
		icon: "fal fa-clock",
		title: "Escrow Extended",
		text: "The escrow for order #[orderId] was extended",
		action: {
			text: "View Order Details",
			link: "/account/orders"
		},
		color: "amber"
	},
	orderComplete: {
		icon: "fal fa-check-circle",
		title: "Order Complete",
		text: "Order #[orderId] was marked as complete",
		action: {
			text: "View Order Details",
			link: "/account/sales"
		},
		color: "green"
	},
	disputeStarted: {
		icon: "fal fa-gavel",
		title: "Dispute Started",
		text: "Order #[orderId] has been disputed by [username]",
		action: {
			text: "View Dispute",
			link: "/account/arbitration"
		},
		color: "amber"
	},
	disputeResolved: {
		icon: "fal fa-box-ballot",
		title: "Dispute Resolved",
		text: "Dispute #[disputeId] has been resolved",
		action: {
			text: "View Dispute",
			link: "/account/arbitration"
		},
		color: "amber"
	},
	listingSuspended: {
		icon: "fal fa-ban",
		title: "Listing Suspended",
		text: "Listing #[listingId] was suspended - Reason: [suspendReason]",
		action: {
			text: "",
			link: ""
		},
		color: "red"
	},
	accountSuspended: {
		icon: "fal fa-ban",
		title: "Account Suspended",
		text: "Your account was suspended - Reason: [suspendReason]",
		action: {
			text: "",
			link: ""
		},
		color: "red"
	}
};

/*
    DUMMY DATA
*/

export const dummyData = { "AF": "238.47", "AX": "238.47", "AL": "238.47", "DZ": "238.47", "AS": "238.47", "AD": "238.47", "AO": "238.47", "AI": "238.47", "AG": "238.47", "AR": "238.47", "AM": "238.47", "AW": "238.47", "AU": "238.47", "AT": "238.47", "AZ": "238.47", "BS": "238.47", "BH": "238.47", "BD": "238.47", "BB": "238.47", "BY": "238.47", "BE": "238.47", "BZ": "238.47", "BJ": "238.47", "BM": "238.47", "BT": "238.47", "BO": "238.47", "BQ": "238.47", "BA": "238.47", "BW": "238.47", "BR": "238.47", "IO": "238.47", "BN": "238.47", "BG": "238.47", "BF": "238.47", "BI": "238.47", "KH": "238.47", "CM": "238.47", "CA": "238.47", "CV": "238.47", "KY": "238.47", "CF": "238.47", "TD": "238.47", "CL": "238.47", "CN": "238.47", "CX": "238.47", "CC": "238.47", "CO": "238.47", "KM": "238.47", "CG": "238.47", "CK": "238.47", "CR": "238.47", "HR": "238.47", "CU": "238.47", "CW": "238.47", "CY": "238.47", "CZ": "238.47", "CD": "238.47", "DK": "238.47", "DJ": "238.47", "DM": "238.47", "DO": "238.47", "TL": "238.47", "EC": "238.47", "EG": "238.47", "SV": "238.47", "GQ": "238.47", "ER": "238.47", "EE": "238.47", "SZ": "238.47", "ET": "238.47", "FK": "238.47", "FO": "238.47", "FJ": "238.47", "FI": "238.47", "FR": "238.47", "GF": "238.47", "PF": "238.47", "TF": "238.47", "GA": "238.47", "GM": "238.47", "GE": "238.47", "DE": "238.47", "GH": "238.47", "GI": "238.47", "GR": "238.47", "GL": "238.47", "GD": "238.47", "GP": "238.47", "GU": "238.47", "GT": "238.47", "GG": "238.47", "GN": "238.47", "GW": "238.47", "GY": "238.47", "HT": "238.47", "VA": "238.47", "HN": "238.47", "HK": "238.47", "HU": "238.47", "IS": "238.47", "IN": "238.47", "ID": "238.47", "IR": "238.47", "IQ": "238.47", "IE": "238.47", "IM": "238.47", "IL": "238.47", "IT": "238.47", "CI": "238.47", "JM": "238.47", "JP": "238.47", "JE": "238.47", "JO": "238.47", "KZ": "238.47", "KE": "238.47", "KI": "238.47", "KW": "238.47", "KG": "238.47", "LA": "238.47", "LV": "238.47", "LB": "238.47", "LS": "238.47", "LR": "238.47", "LY": "238.47", "LI": "238.47", "LT": "238.47", "LU": "238.47", "MO": "238.47", "MG": "238.47", "MW": "238.47", "MY": "238.47", "MV": "238.47", "ML": "238.47", "MT": "238.47", "MH": "238.47", "MQ": "238.47", "MR": "238.47", "MU": "238.47", "YT": "238.47", "MX": "238.47", "MD": "238.47", "MC": "238.47", "MN": "238.47", "ME": "238.47", "MS": "238.47", "MA": "238.47", "MZ": "238.47", "MM": "238.47", "NA": "238.47", "NR": "238.47", "NP": "238.47", "NL": "238.47", "NC": "238.47", "NZ": "238.47", "NI": "238.47", "NE": "238.47", "NG": "238.47", "NU": "238.47", "NF": "238.47", "KP": "238.47", "MK": "238.47", "MP": "238.47", "NO": "238.47", "OM": "238.47", "PK": "238.47", "PW": "238.47", "PS": "238.47", "PA": "238.47", "PG": "238.47", "PY": "238.47", "PE": "238.47", "PH": "238.47", "PN": "238.47", "PL": "238.47", "PT": "238.47", "PR": "238.47", "QA": "238.47", "RO": "238.47", "RU": "238.47", "RW": "238.47", "RE": "238.47", "BL": "238.47", "SH": "238.47", "KN": "238.47", "LC": "238.47", "MF": "238.47", "PM": "238.47", "VC": "238.47", "WS": "238.47", "SM": "238.47", "ST": "238.47", "SA": "238.47", "SN": "238.47", "RS": "238.47", "SC": "238.47", "SL": "238.47", "SG": "238.47", "SX": "238.47", "SK": "238.47", "SI": "238.47", "SB": "238.47", "SO": "238.47", "ZA": "238.47", "GS": "238.47", "KR": "238.47", "SS": "238.47", "ES": "238.47", "LK": "238.47", "SD": "238.47", "SR": "238.47", "SJ": "238.47", "SE": "238.47", "CH": "238.47", "SY": "238.47", "TW": "238.47", "TJ": "238.47", "TZ": "238.47", "TH": "238.47", "TG": "238.47", "TK": "238.47", "TO": "238.47", "TT": "238.47", "TN": "238.47", "TR": "238.47", "TM": "238.47", "TC": "238.47", "TV": "238.47", "UG": "238.47", "UA": "238.47", "AE": "238.47", "GB": "16.10", "US": "238.47", "UY": "238.47", "UZ": "238.47", "VU": "238.47", "VE": "238.47", "VN": "238.47", "VG": "238.47", "VI": "238.47", "WF": "238.47", "EH": "238.47", "YE": "238.47", "ZM": "238.47", "ZW": "238.47" };

export const dummyData2 = { "GB": "0.00", "GB-N": "0.00" };

export const dummyAccount = {
	type: "web3",
	avatar: "/assets/images/strx_storex_256.png",
	displayName: "Storex Marketplace Ltd",
	country: "GB",
	kyc: true,
	business: true,
	rating: 5,
	website: "https://storex.io",
	createdAt: "2022-10-03T14:12:45.533Z"
};

export const ebayCategoryMap = {
	1: {
		category: "category_antiques_collectables",
		34: "sub_memorabilia",
		113: "sub_tools_hardware",
		124: "sub_manuscripts",
		137: "sub_memorabilia",
		152: "sub_memorabilia",
		412: "sub_memorabilia",
		417: "sub_memorabilia",
		898: "sub_card_games",
		907: "sub_decorative",
		914: "sub_photographs_postcards",
		966: "sub_tools_hardware",
		1401: "sub_militaria",
		1404: "sub_furniture",
		1430: "sub_metalware",
		3213: "sub_rocks_minerals",
		13658: "sub_memorabilia",
		13777: "sub_decorative",
		13849: "sub_tools_hardware",
		13905: "sub_furniture",
		13956: "sub_militaria",
		14005: "sub_memorabilia",
		14429: "sub_autographs",
		29832: "sub_tools_hardware",
		39507: "sub_vintage_retro",
		66502: "sub_tools_hardware",
		69851: "sub_vintage_retro",
		165800: "sub_memorabilia",
		182982: "sub_card_games",
		259135: "sub_memorabilia",
		261650: "sub_jewelry",
		262344: "sub_memorabilia",
		262413: "sub_photographs_postcards",
		263076: "sub_memorabilia"
	},
	99: {
		category: "category_other"
	},
	220: {
		category: "category_toys_games",
		233: "sub_games",
		246: "sub_action_figures",
		436: "sub_dolls",
		1188: "sub_models_kits",
		2536: "sub_games",
		2562: "sub_rc_toys",
		2613: "sub_jigsaws_puzzles",
		2631: "sub_toy_soldiers",
		11731: "sub_educational_toys",
		11743: "sub_outdoor_toys",
		19071: "sub_electronic_pets",
		19077: "sub_food_toys",
		19169: "sub_educational_toys",
		19192: "sub_action_figures",
		49019: "sub_soft_toys",
		58799: "sub_games",
		180250: "sub_models_kits",
		183446: "sub_construction_toys"
	},
	237: {
		category: "category_toys_games",
		238: "sub_dolls",
		1202: "sub_dolls",
		2440: "sub_dolls",
		262353: "sub_soft_toys"
	},
	260: {
		category: "category_antiques_collectables",
		261: "sub_photographs_postcards",
		3478: "sub_photographs_postcards",
		3499: "sub_photographs_postcards",
		4742: "sub_photographs_postcards",
		4752: "sub_photographs_postcards",
		7898: "sub_photographs_postcards",
		65174: "sub_photographs_postcards",
		170137: "sub_photographs_postcards",
		179377: "sub_photographs_postcards",
		181416: "sub_photographs_postcards",
		181417: "sub_photographs_postcards",
		181420: "sub_photographs_postcards",
		181421: "sub_photographs_postcards",
		181422: "sub_photographs_postcards",
		181423181424: "sub_photographs_postcards"
	},
	267: {
		category: "category_books_music",
		280: "sub_magazines",
		29792: "sub_audio_books",
		45110: "sub_audio_accessories",
		118254: "sub_non_fiction_books",
		184644: "sub_textbooks_education"
	},
	281: {
		category: "category_fashion",
		491: "sub_jewelry_watches",
		4196: "sub_jewelry_watches",
		10290: "sub_jewelry_watches",
		10968: "sub_jewelry_watches",
		84605: "sub_kids_accessories",
		91427: "sub_jewelry_watches",
		110633: "sub_jewelry_watches",
		164352: "sub_jewelry_watches",
		260324: "sub_jewelry_watches",
		261986: "sub_jewelry_watches",
		261997: "sub_jewelry_watches",
		262022: "sub_jewelry_watches",
		262023: "sub_jewelry_watches",
		262024: "sub_jewelry_watches",
		262025: "sub_jewelry_watches",
	},
	293: {
		category: "category_electronics",
		1500: "sub_home_audio",
		3286: "sub_home_audio",
		15052: "sub_headphones",
		32852: "sub_home_audio",
		48446: "sub_batteries_power",
		178894: "sub_television_accessories",
		183067: "sub_virtual_reality",
		185067: "sub_cameras_photography",

	},
	316: {
		category: "category_services_gigs",
		20943: "sub_writing_translation",
		47104: "sub_programming_tech",
		47126: "sub_graphics_design",
		47131: "sub_graphics_design",
		50343: "sub_lifestyle",
		50355: "sub_writing_translation",
		170048: "sub_lifestyle"
	},
	550: {
		category: "category_hobbies_leisure",
		360: "sub_framing",
		551: "sub_framing",
		552: "sub_framing",
		553: "sub_sculpting_ceramics",
		554: "sub_scrapbooking_paper",
		2211: "sub_framing",
		28009: "sub_framing",
		156196: "sub_fabric"
	},
	619: {
		category: "category_hobbies_leisure",
		3858: "sub_guitars_basses",
		10181: "sub_wind_woodwind",
		12922: "sub_music_accessories",
		16212: "sub_wind_woodwind",
		48458: "sub_dj_equipment",
		175696: "sub_audio_equipment",
		180008: "sub_audio_equipment",
		180010: "sub_keyboards_pianos",
		180012: "sub_percussion_instruments",
		180014: "sub_audio_equipment",
		180015: "sub_music_accessories",
		180016: "sub_string_instruments",
		182150: "sub_music_accessories"
	},
	625: {
		category: "category_electronics",
		3326: "sub_cameras_photography",
		4684: "sub_cameras_photography",
		11724: "sub_cameras_photography",
		15200: "sub_drones",
		21162: "sub_cameras_photography",
		27432: "sub_cameras_photography",
		28179: "sub_cameras_photography",
		30078: "sub_cameras_photography",
		30090: "sub_cameras_photography",
		31388: "sub_cameras_photography",
		45089: "sub_cameras_photography",
		64353: "sub_cameras_photography",
		69323: "sub_cameras_photography",
		78997: "sub_cameras_photography",
		150044: "sub_cameras_photography",
		179697: "sub_drones",
		182074: "sub_cameras_photography"
	},
	870: {
		category: "category_home_garden",
		262359: "sub_drinkware",
		262364: "sub_cookware",
		262410: "sub_home_furniture"
	},
	888: {
		category: "category_sporting",
		1492: "sub_fishing",
		1513: "sub_golf",
		7294: "sub_cycling",
		7301: "sub_hunting",
		15273: "sub_fitness_yoga_equipment",
		16034: "sub_camping",
		36259: "sub_winter_sports",
		159134: "sub_tennis",
		177890: "sub_airsoft",
		179767: "sub_boxing"
	},
	1249: {
		category: "category_electronics",
		38583: "sub_video_game_accessories",
		54968: "sub_video_game_accessories",
		139971: "sub_video_game_consoles",
		139973: "sub_video_games",
		156595: "sub_video_game_accessories",
		156597: "sub_video_game_accessories",
		171833: "sub_video_game_accessories",
		182174: "sub_video_game_accessories",
		182175: "sub_video_game_accessories",
	},
	1281: {
		category: "category_home_garden",
		301: "sub_pet_supplies",
		1285: "sub_pet_supplies",
		20734: "sub_pet_supplies",
		20737: "sub_pet_supplies",
		20742: "sub_pet_supplies",
		20754: "sub_pet_supplies",
		48760: "sub_pet_supplies",
		116391: "sub_pet_supplies",
		177801: "sub_pet_supplies",
		259318: "sub_pet_supplies",
		259319: "sub_pet_supplies",
		259320: "sub_pet_supplies"
	},
	1305: {
		category: "category_services_gigs",
		1306: "sub_tickets",
		170591: "sub_tickets",
		170594: "sub_tickets",
		173633: "sub_tickets",
		173634: "sub_tickets",
		173635: "sub_tickets",
		178892: "sub_tickets"
	},
	2984: {
		category: "category_home_garden"
	},
	3252: {
		category: "category_services_gigs",
		1310: "sub_tickets",
		3253: "sub_tickets",
		16078: "sub_tickets",
		16080: "sub_tickets",
		16123: "sub_tickets",
		29578: "sub_tickets",
		93838: "sub_tickets",
		98982: "sub_tickets",
		147399: "sub_tickets",
		164802: "sub_tickets",
		164803: "sub_tickets",
		173520: "sub_tickets",
		183477: "sub_tickets"
	},
	10542: {
		category: "category_other"
	},
	11116: {
		category: "category_antiques_collectables",
		253: "sub_coins_precious_metals",
		256: "sub_coins_precious_metals",
		3377: "sub_coins_precious_metals",
		3411: "sub_coins_precious_metals",
		3412: "sub_coins_precious_metals",
		3444: "sub_coins_precious_metals",
		3452: "sub_coins_precious_metals",
		4733: "sub_coins_precious_metals",
		18466: "sub_coins_precious_metals",
		39482: "sub_coins_precious_metals",
		83274: "sub_coins_precious_metals",
		169305: "sub_coins_precious_metals",
		179197: "sub_coins_precious_metals"
	},
	11232: {
		category: "category_electronics",
		309: "sub_dvd_bluray",
		381: "sub_dvd_bluray",
		617: "sub_dvd_bluray",
		41676: "sub_dvd_bluray",
		52554: "sub_dvd_bluray",
		63821: "sub_dvd_bluray",
		132975: "sub_dvd_bluray"
	},
	11233: {
		category: "category_books_music",
		52473: "sub_audio_accessories",
		176983: "sub_cassettes",
		176984: "sub_cds",
		176985: "sub_vinyl_records"
	},
	11450: {
		category: "category_fashion",
		171146: "sub_kids_clothing",
		260010: "sub_womens_clothing",
		260012: "sub_mens_clothing",
		260018: "sub_kids_clothing"
	},
	11700: {
		category: "category_home_garden",
		299: "sub_household",
		631: "sub_garden_tools",
		3197: "sub_home_furniture",
		10033: "sub_home_furniture",
		20444: "sub_home_furniture",
		20563: "sub_home_furniture",
		20571: "sub_home_furniture",
		20625: "sub_home_furniture",
		20697: "sub_home_furniture",
		20710: "sub_home_furniture",
		26677: "sub_home_furniture",
		63514: "sub_household",
		159907: "sub_home_furniture",
		159912: "sub_outdoor_furniture",
		170090: "sub_outdoor_furniture",
		176988: "sub_home_furniture",
		177073: "sub_home_furniture",
		178069: "sub_plants_seeds",
		262975: "sub_household"
	},
	12576: {
		category: "category_business_office",
		25298: "sub_office_furniture",
		26238: "sub_displays_stands"
	},
	14339: {
		category: "category_hobbies_leisure",
		3122: "sub_hand_crafted",
		11783: "sub_art_supplies",
		11788: "sub_scrapbooking_paper",
		28102: "sub_art_supplies",
		28131: "sub_leathercrafts",
		28162: "sub_fabric",
		31723: "sub_hand_crafted",
		71183: "sub_hand_crafted",
		116652: "sub_child_crafts",
		160667: "sub_hand_crafted",
		160706: "sub_needlecrafts",
		160737: "sub_sewing",
		163778: "sub_mosaic",
		183118: "sub_fabric",
		183302: "sub_sculpting_ceramics"
	},
	15032: {
		category: "category_phones_smart_watches",
		9355: "sub_mobile_phones",
		9394: "sub_mobile_phone_accessories",
		43304: "sub_mobile_phone_parts",
		146492: "sub_mobile_phone_accessories",
		178893: "sub_smart_watches",
		182064: "sub_smart_watch_accessories",
		182073: "sub_mobile_phones"
	},
	20081: {
		category: "category_antiques_collectables",
		20091: "sub_furniture",
		20096: "sub_coins_precious_metals",
		23048: "sub_manuscripts",
		37958: "sub_maps_globes",
		156323: "sub_tools_hardware",
		181726: "sub_musical"
	},
	26395: {
		category: "category_health_beauty",
		11778: "sub_health_care",
		11838: "sub_bath_body",
		11854: "sub_hair_styling",
		11863: "sub_skin_care",
		31414: "sub_vision_care",
		31769: "sub_oral_care",
		31772: "sub_sun_tanning",
		31786: "sub_makeup",
		33914: "sub_tattoos_art",
		36447: "sub_bath_body",
		47945: "sub_nail_care",
		67588: "sub_health_care",
		67659: "sub_natural_alternative",
		180345: "sub_fragrances",
		180959: "sub_vitamins_supplements",
		183497: "sub_electronic_smoking"
	},
	45100: {
		category: "category_antiques_collectables",
		57: "sub_autographs",
		196: "sub_memorabilia",
		1424: "sub_memorabilia",
		2312: "sub_memorabilia",
		2329: "sub_memorabilia",
		2362: "sub_memorabilia",
		45101: "sub_memorabilia",
		104412: "sub_autographs"
	},
	58058: {
		category: "category_computers_hardware",
		165: "sub_drives",
		3676: "sub_computer_peripherals",
		11176: "sub_home_networking",
		18793: "sub_software",
		31530: "sub_laptops_netbooks",
		162497: "sub_monitors_accessories",
		171957: "sub_desktop_computers",
		171961: "sub_printers",
		175672: "sub_laptops_netbooks",
		175673: "sub_computer_components_parts",
		175698: "sub_home_networking",
		182094: "sub_computer_components_parts",
		183062: "sub_printers"
	},
	64482: {
		category: "category_antiques_collectables",
		51: "sub_autographs",
		212: "sub_card_games",
		24409: "sub_memorabilia",
		50115: "sub_autographs",
		50116: "sub_memorabilia",
		50123: "sub_memorabilia",
		262343: "sub_card_games"
	},
	172008: {
		category: "category_services_gigs",
		31411: "sub_cards_coupons",
		172009: "sub_cards_coupons",
		172010: "sub_cards_coupons",
		172036: "sub_cards_coupons",
		176950: "sub_cards_coupons"
	}
};

export const dummyCategories = {
	"": {
		subcategories: {
			"": {
				url: ""
			}
		},
		icon: "",
		url: ""
	},
	category_antiques_collectables: {
		subcategories: {
			sub_autographs: {
				url: "/autographs"
			},
			sub_badges_patches: {
				url: "/badges-patches"
			},
			sub_card_games: {
				url: "/card-games"
			},
			sub_coins_precious_metals: {
				url: "/coins-precious-metals"
			},
			sub_decorative: {
				url: "/decorative"
			},
			sub_flags: {
				url: "/flags"
			},
			sub_furniture: {
				url: "/furniture"
			},
			sub_jewelry: {
				url: "/jewelry"
			},
			sub_manuscripts: {
				url: "/manuscripts"
			},
			sub_maps_globes: {
				url: "/maps-globes"
			},
			sub_memorabilia: {
				url: "/memorabilia"
			},
			sub_metalware: {
				url: "/metalware"
			},
			sub_militaria: {
				url: "/militaria"
			},
			sub_musical: {
				url: "/musical"
			},
			sub_photographs_postcards: {
				url: "/photographs-postcards"
			},
			sub_rocks_minerals: {
				url: "/rocks-minerals"
			},
			sub_tools_hardware: {
				url: "/tools-hardware"
			},
			sub_vintage_retro: {
				url: "/vintage-retro"
			},
			sub_woodenware: {
				url: "/woodenware"
			},
			sub_other: {
				url: "/other"
			}
		},
		icon: "fa-globe-stand",
		url: "/category/antiques-collectables"
	},
	category_books_music: {
		subcategories: {
			sub_audio_accessories: {
				url: "/audio-accessories"
			},
			sub_audio_books: {
				url: "/audio-books"
			},
			sub_cassettes: {
				url: "/cassettes"
			},
			sub_cds: {
				url: "/cds"
			},
			sub_comic_books: {
				url: "/comic-books"
			},
			sub_fiction_books: {
				url: "/fiction-books"
			},
			sub_magazines: {
				url: "/magazines"
			},
			sub_non_fiction_books: {
				url: "/non-fiction-books"
			},
			sub_textbooks_education: {
				url: "/textbooks-education"
			},
			sub_vinyl_records: {
				url: "/vinyl-records"
			},
			sub_other: {
				url: "/other"
			}
		},
		icon: "fa-book",
		url: "/category/books-music"
	},
	category_business_office: {
		subcategories: {
			sub_displays_stands: {
				url: "/displays-stands"
			},
			sub_equipment_supplies: {
				url: "/equipment-supplies"
			},
			sub_office_furniture: {
				url: "/office-furniture"
			},
			sub_presentation_projectors: {
				url: "/presentation-projectors"
			},
			sub_stationery: {
				url: "/stationery"
			},
			sub_other: {
				url: "/other"
			}
		},
		icon: "fa-briefcase",
		url: "/category/business-office"
	},
	category_computers_hardware: {
		subcategories: {
			sub_computer_components_parts: {
				url: "/computer-components-parts"
			},
			sub_computer_peripherals: {
				url: "/computer-peripherals"
			},
			sub_desktop_computers: {
				url: "/desktop-computers"
			},
			sub_drives: {
				url: "/drives"
			},
			sub_storage_media: {
				url: "/storage-media"
			},
			sub_home_networking: {
				url: "/home-networking"
			},
			sub_laptops_netbooks: {
				url: "/laptops-netbooks"
			},
			sub_monitors_accessories: {
				url: "/monitors-accessories"
			},
			sub_printers: {
				url: "/printers"
			},
			sub_scanners_supplies: {
				url: "/scanners-supplies"
			},
			sub_software: {
				url: "/software"
			},
			sub_other: {
				url: "/other"
			}
		},
		icon: "fa-desktop-alt",
		url: "/category/computers-hardware"
	},
	category_electronics: {
		subcategories: {
			sub_batteries_power: {
				url: "/batteries-power"
			},
			sub_cameras_photography: {
				url: "/cameras-photography"
			},
			sub_drones: {
				url: "/drones"
			},
			sub_dvd_bluray: {
				url: "/dvd-bluray"
			},
			sub_headphones: {
				url: "/headphones"
			},
			sub_home_appliances: {
				url: "/home-appliances"
			},
			sub_home_audio: {
				url: "/home-audio"
			},
			sub_home_cinema: {
				url: "/home-cinema"
			},
			sub_tablets_ereaders: {
				url: "/tablets-ereaders"
			},
			sub_television_accessories: {
				url: "/television-accessories"
			},
			sub_televisions: {
				url: "/televisions"
			},
			sub_video_game_accessories: {
				url: "/video-game-accessories"
			},
			sub_video_game_consoles: {
				url: "/video-game-consoles"
			},
			sub_video_games: {
				url: "/video-games"
			},
			sub_virtual_reality: {
				url: "/virtual-reality"
			},
			sub_other: {
				url: "/other"
			}
		},
		icon: "fa-computer-speaker",
		url: "/category/electronics"
	},
	category_fashion: {
		subcategories: {
			sub_jewelry_watches: {
				url: "/jewelry-watches"
			},
			sub_kids_accessories: {
				url: "/kids-accessories"
			},
			sub_kids_clothing: {
				url: "/kids-clothing"
			},
			sub_kids_shoes: {
				url: "/kids-shoes"
			},
			sub_mens_accessories: {
				url: "/mens-accessories"
			},
			sub_mens_clothing: {
				url: "/mens-clothing"
			},
			sub_mens_shoes: {
				url: "/mens-shoes"
			},
			sub_womens_accessories: {
				url: "/womens-accessories"
			},
			sub_womens_clothing: {
				url: "/womens-clothing"
			},
			sub_womens_shoes: {
				url: "/womens-shoes"
			},
			sub_other: {
				url: "/other"
			}
		},
		icon: "fa-tshirt",
		url: "/category/fashion"
	},
	category_health_beauty: {
		subcategories: {
			sub_bath_body: {
				url: "/bath-body"
			},
			sub_electronic_smoking: {
				url: "/electronic-smoking"
			},
			sub_fragrances: {
				url: "/fragrances"
			},
			sub_hair_styling: {
				url: "/hair-styling"
			},
			sub_health_care: {
				url: "/health-care"
			},
			sub_makeup: {
				url: "/makeup"
			},
			sub_nail_care: {
				url: "/nail-care"
			},
			sub_natural_alternative: {
				url: "/natural-alternative"
			},
			sub_oral_care: {
				url: "/oral-care"
			},
			sub_shaving_removal: {
				url: "/shaving-removal"
			},
			sub_skin_care: {
				url: "/skin-care"
			},
			sub_sun_tanning: {
				url: "/sun-tanning"
			},
			sub_tattoos_art: {
				url: "/tattoos-art"
			},
			sub_vision_care: {
				url: "/vision-care"
			},
			sub_vitamins_supplements: {
				url: "/vitamins-supplements"
			},
			sub_other: {
				url: "/other"
			}
		},
		icon: "fa-pills",
		url: "/category/health-beauty"
	},
	category_hobbies_leisure: {
		subcategories: {
			sub_art_supplies: {
				url: "/art-supplies"
			},
			sub_audio_equipment: {
				url: "/audio-equipment"
			},
			sub_beads_jewelry_making: {
				url: "/beads-jewelry-making"
			},
			sub_child_crafts: {
				url: "/childrens-crafts"
			},
			sub_dj_equipment: {
				url: "/dj-equipment"
			},
			sub_fabric: {
				url: "/fabric"
			},
			sub_framing: {
				url: "/framing"
			},
			sub_glass_art: {
				url: "/glass-art"
			},
			sub_guitars_basses: {
				url: "/guitars-basses"
			},
			sub_hand_crafted: {
				url: "/hand-crafted"
			},
			sub_keyboards_pianos: {
				url: "/keyboards-pianos"
			},
			sub_leathercrafts: {
				url: "/leathercrafts"
			},
			sub_mosaic: {
				url: "/mosaic"
			},
			sub_music_accessories: {
				url: "/music-accessories"
			},
			sub_needlecrafts: {
				url: "/needlecrafts"
			},
			sub_percussion_instruments: {
				url: "/percussion-instruments"
			},
			sub_scrapbooking_paper: {
				url: "/scrapbooking-paper"
			},
			sub_sculpting_ceramics: {
				url: "/sculpting-ceramics"
			},
			sub_sewing: {
				url: "/sewing"
			},
			sub_string_instruments: {
				url: "/string-instruments"
			},
			sub_wind_woodwind: {
				url: "/wind-woodwind"
			},
			sub_woodworking: {
				url: "/woodworking"
			},
			sub_other: {
				url: "/other"
			}
		},
		icon: "fa-paint-brush",
		url: "/category/hobbies-leisure"
	},
	category_home_garden: {
		subcategories: {
			sub_cookware: {
				url: "/cookware-dinnerware"
			},
			sub_drinkware : {
				url: "/drinkware"
			},
			sub_garden_patio: {
				url: "/garden-patio"
			},
			sub_garden_tools: {
				url: "/garden-tools"
			},
			sub_home_furniture: {
				url: "/home-furniture"
			},
			sub_household: {
				url: "/household-supplies"
			},
			sub_lawn_mowers: {
				url: "/lawn-mowers"
			},
			sub_outdoor_furniture: {
				url: "/outdoor-furniture"
			},
			sub_pet_supplies: {
				url: "/pet-supplies"
			},
			sub_plant_care: {
				url: "/plant-care"
			},
			sub_plants_seeds: {
				url: "/plants-seeds"
			},
			sub_other: {
				url: "/other"
			}
		},
		icon: "fa-home-alt",
		url: "/category/home-garden"
	},
	category_jewelry_watches: {
		subcategories: {
			sub_body_jewelry: {
				url: "/body-jewelry"
			},
			sub_child_jewelry: {
				url: "/child-jewelry"
			},
			sub_child_watches: {
				url: "/child-watches"
			},
			sub_costume_jewelry: {
				url: "/costume-jewelry"
			},
			sub_fine_jewelry: {
				url: "/fine-jewelry"
			},
			sub_mens_jewelry: {
				url: "/mens-jewelry"
			},
			sub_mens_watches: {
				url: "/mens-watches"
			},
			sub_womens_jewelry: {
				url: "/womens-jewelry"
			},
			sub_womens_watches: {
				url: "/womens-watches"
			},
			sub_other: {
				url: "/other"
			}
		},
		icon: "fa-watch",
		url: "/category/jewelry-watches"
	},
	category_phones_smart_watches: {
		subcategories: {
			sub_home_phones_accessories: {
				url: "/home-phones-accessories"
			},
			sub_mobile_phones: {
				url: "/mobile-phones"
			},
			sub_mobile_phone_accessories: {
				url: "/mobile-phone-accessories"
			},
			sub_mobile_phone_parts: {
				url: "/mobile-phone-parts"
			},
			sub_smart_watch_accessories: {
				url: "/smart-watch-accessories"
			},
			sub_smart_watches: {
				url: "/smart-watches"
			},
			sub_other: {
				url: "/other"
			}
		},
		icon: "fa-mobile",
		url: "/category/phones-smart-watches"
	},
	category_services_gigs: {
		subcategories: {
			sub_business: {
				url: "/business"
			},
			sub_digital_marketing: {
				url: "/digital-marketing"
			},
			sub_graphics_design: {
				url: "/graphics-design"
			},
			sub_cards_coupons: {
				url: "/cards-coupons"
			},
			sub_lifestyle: {
				url: "/lifestyle"
			},
			sub_music_audio: {
				url: "/music-audio"
			},
			sub_programming_tech: {
				url: "/programming-tech"
			},
			sub_tickets: {
				url: "/tickets-events-travel"
			},
			sub_video_animation: {
				url: "/video-animation"
			},
			sub_writing_translation: {
				url: "/writing-translation"
			},
			sub_other: {
				url: "/other"
			}
		},
		icon: "fa-comment-alt",
		url: "/category/services-gigs"
	},
	category_sporting: {
		subcategories: {
			sub_airsoft: {
				url: "/airsoft"
			},
			sub_american_football: {
				url: "/american-football"
			},
			sub_boxing: {
				url: "/boxing"
			},
			sub_camping: {
				url: "/camping"
			},
			sub_cricket: {
				url: "/cricket"
			},
			sub_cycling: {
				url: "/cycling"
			},
			sub_fishing: {
				url: "/fishing"
			},
			sub_fitness_tech: {
				url: "/fitness-tech"
			},
			sub_fitness_yoga_equipment: {
				url: "/fitness-yoga-equipment"
			},
			sub_football: {
				url: "/football"
			},
			sub_golf: {
				url: "/golf"
			},
			sub_hunting: {
				url: "/hunting"
			},
			sub_martial_arts: {
				url: "/martial-arts"
			},
			sub_paintball: {
				url: "/paintball"
			},
			sub_rugby: {
				url: "/rugby"
			},
			sub_skateboarding: {
				url: "/skateboarding"
			},
			sub_strength_training: {
				url: "/strength-training"
			},
			sub_swimming: {
				url: "/swimming"
			},
			sub_table_tennis: {
				url: "/table-tennis"
			},
			sub_tennis: {
				url: "/tennis"
			},
			sub_winter_sports: {
				url: "/winter-sports"
			},
			sub_other: {
				url: "/other"
			}
		},
		icon: "fa-futbol",
		url: "/category/sporting"
	},
	category_toys_games: {
		subcategories: {
			sub_action_figures: {
				url: "/action-figures"
			},
			sub_construction_toys: {
				url: "/construction-toys"
			},
			sub_creative_toys: {
				url: "/creative-toys"
			},
			sub_dolls: {
				url: "/dolls"
			},
			sub_educational_toys: {
				url: "/educational-toys"
			},
			sub_electronic_pets: {
				url: "/electronic-pets"
			},
			sub_food_toys: {
				url: "/food-toys"
			},
			sub_games: {
				url: "/games"
			},
			sub_jigsaws_puzzles: {
				url: "/jigsaws-puzzles"
			},
			sub_models_kits: {
				url: "/models-kits"
			},
			sub_outdoor_toys: {
				url: "/outdoor-toys"
			},
			sub_rc_toys: {
				url: "/rc-toys"
			},
			sub_soft_toys: {
				url: "/soft-toys"
			},
			sub_toy_soldiers: {
				url: "/toy-soldiers"
			},
			sub_wargames_rp: {
				url: "/wargames-rp"
			},
			sub_other: {
				url: "/other"
			}
		},
		icon: "fa-gamepad-alt",
		url: "/category/toys-games"
	},
	category_vehicle_parts: {
		subcategories: {
			sub_car_accessories: {
				url: "/car-accessories"
			},
			sub_car_care: {
				url: "/car-care"
			},
			sub_car_parts: {
				url: "/car-parts"
			},
			sub_car_tech: {
				url: "/car-tech"
			},
			sub_car_tuning: {
				url: "/car-tuning"
			},
			sub_car_wheels: {
				url: "/car-wheels"
			},
			sub_helmets_protection: {
				url: "/helmets-protection"
			},
			sub_dash_cams: {
				url: "/dash-cams"
			},
			sub_garage_equipment: {
				url: "/garage-equipment"
			},
			sub_motorcycle_accessories: {
				url: "/motorcycle-accessories"
			},
			sub_motorcycle_parts: {
				url: "/motorcycle-parts"
			},
			sub_motorcycle_wheels: {
				url: "/motorcycle-wheels"
			},
			sub_oils_fluids: {
				url: "/oils-fluids"
			},
			sub_vehicle_services: {
				url: "/vehicle-services"
			},
			sub_other: {
				url: "/other"
			}
		},
		icon: "fa-car-battery",
		url: "/category/vehicle-parts"
	},
	category_other: {
		subcategories: {
			sub_other: {
				url: "/other"
			}
		},
		icon: "fa-box-full",
		url: "/category/other"
	}
};

export const dummySpotlight = [
	{ name: "phone-001", title: "iPhone 16 Pro", subtitle: null, description: "The first iPhone designed for Apple Intelligence. Personal, private, powerful. All-new A18 Pro chip powers unrivalled intelligence. And unprecedented perform­ance.", url: "/category/phones-smart-watches/mobile-phones", brand: null },
	{ name: "gpu-001", title: "GeForce RTX 40 Series", subtitle: "The Ultimate Play", description: "Computers equipped with GeForce RTX 40 Series GPUs deliver the ultimate performance for gamers and creators.", url: "/category/computers-hardware/computer-components-parts", brand: null }
];

export const dummyWeeklyDeal = {
	_id: "",
	title: "",
	category: "",
	subcategory: "",
	thumbnail: "",
	images : [],
	seller: {
		id: "",
		created: 0,
		username: "",
		avatar: "",
		rating: 0,
		moreListings: [
		]
	},
	location: "",
	price: "",
	postage: {
		location: "",
		domestic: {
			available: [],
			service: "",
			estimate: ""
		},
		international: {
			available: [],
			service: "",
			estimate: ""
		}
	},
	stock: 0,
	options: [
	],
	variations: [
		{ id: -1, stock: 0, price: "0" },
	],
	currencies: [],
	expires: 0,
	reviews: {
		rating: 0,
		count: 0,
		topRated: ""
	},
	description: ""
};

export const dummyListings = {
	"64O30C1G60O30C1H": {
		_id: "64O30C1G60O30C1H",
		broadcast: true,
		escrow: true,
		title: "PCSPECIALIST Vortex ST-S Gaming PC - Intel Core i7 - RTX 3070 - 1TB HDD & 512GB SSD",
		category: "category_computers_hardware",
		subcategory: "sub_desktop_computers",
		thumbnail: "https://media.currys.biz/i/currysprod/10222262",
		images : [
			{ id: 0, src: "https://media.currys.biz/i/currysprod/10222262" },
			{ id: 1, src: "https://media.currys.biz/i/currysprod/10222262_003" },
			{ id: 2, src: "https://media.currys.biz/i/currysprod/10222262_005" },
			{ id: 3, src: "https://media.currys.biz/i/currysprod/10222262_006" },
			{ id: 4, src: "https://media.currys.biz/i/currysprod/10222262_008" },
			{ id: 5, src: "https://media.currys.biz/i/currysprod/10222262_009" },
			{ id: 6, src: "https://media.currys.biz/i/currysprod/10222262_010" },
			{ id: 7, src: "https://media.currys.biz/i/currysprod/10222262_011" },
			{ id: 8, src: "https://media.currys.biz/i/currysprod/10222262_012" }
		],
		seller: {
			id: "storex",
			created: 1658869640,
			username: "Storex",
			avatar: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/strx.png",
			rating: 4.8,
			listings: [
				{ id: "64O30C1G60O30C1H", title: "PCSPECIALIST Vortex ST-S Gaming PC - Intel Core i7 - RTX 3070 - 1TB HDD & 512GB SSD", thumbnail: "https://media.currys.biz/i/currysprod/10222262", reviews: { rating: 5, count: 1, topRated: "Good Price" }, price: "1399.99" },
				{ id: "64O30C1G60O30C1H", title: "MSI Optix G24C4 Full HD 24 inch Curved LED Gaming Monitor - Black", thumbnail: "https://media.currys.biz/i/currysprod/10202550", reviews: { rating: 5, count: 1, topRated: "Good Price" }, price: "169.99" },
				{ id: "64O30C1G60O30C1H", title: "RAZER Viper 8K Optical Gaming Mouse", thumbnail: "https://media.currys.biz/i/currysprod/10220324", reviews: { rating: 5, count: 1, topRated: "Good Price" }, price: "39.99" }
			]
		},
		location: "GB",
		price: "1399.99",
		postage: {
			location: "GB",
			domestic: {
				available: dummyData,
				service: "Royal Mail Special Delivery",
				estimate: "Next Day"
			},
			international: {
				available: dummyData,
				service: "Parcelforce Global Value",
				estimate: "5-7 days"
			}
		},
		stock: 5,
		options: [
			{ id: 0, name: "Memory" },
			{ id: 1, name: "Storage" },
			{ id: 2, name: "Case" }
		],
		variations: [
			// { id: -1, stock: 3, price: "1399.99" },
			{ id: 0, option0: "8GB DDR4", option1: "256GB SSD", option2: "Black", stock: 5, price: "1399.99" },
			{ id: 1, option0: "8GB DDR4", option1: "512GB SSD", option2: "Black", stock: 5, price: "1419.99" },
			{ id: 2, option0: "8GB DDR4", option1: "1TB SSD", option2: "Black", stock: 0, price: "1439.99" },
			{ id: 3, option0: "16GB DDR4", option1: "256GB SSD", option2: "Black", stock: 5, price: "1429.99" },
			{ id: 4, option0: "16GB DDR4", option1: "512GB SSD", option2: "Black", stock: 5, price: "1449.99" },
			{ id: 5, option0: "16GB DDR4", option1: "1TB SSD", option2: "Black", stock: 1, price: "1469.99" }
		],
		currencies: [
			{ name: "USDC", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/usdc.png" },
			{ name: "STRX", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/strx.png" },
			{ name: "XPR", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/xpr.png" },
			{ name: "BTC", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/xbtc.png" },
			{ name: "ETH", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/xeth.png" },
			{ name: "BNB", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/xbnb.png" }
		],
		expires: 1660830829,
		reviews: {
			rating: 4.8,
			count: 3,
			topRated: "Good Quality"
		},
		description: "<b>Eight-cores of processing power</b><br/><br/>Run the latest releases with the PCSpecialist Vortex ST-S Gaming PC. Offering eight-cores of processing power, easily multitask with the 10th generation Intel® i7 processor. Quickly switch back and forth between a game of DOTA, streaming music and browsing the web - all lag-free.<br/><br/><b>Immersive graphics</b><br/><br/>Powered by NVIDIA Ampere architecture, the RTX 3070 graphics card is able to handle any game you like, no matter how big the map or how detailed the scenery is. It's VR ready too. So put on your headset and get immersed in virtual worlds, whether you're exploring the galaxy or sneaking around a haunted house. All with ray tracing.<br/><br/><b>Room for all your games</b><br/><br/>With a whopping 2 TB of hard drive storage, you won't have to delete old games to make space for new ones. Plus, with an extra 512 GB SSD drive on top, your saves will load in an instant. So you can get right back to playing.",
		stats: {
			sales: 2,
			impressions: 137,
			clicks: 24
		}
	},
	"64O30C1G60O30C1I": {
		_id: "64O30C1G60O30C1I",
		broadcast: true,
		title: 'MSI Optix G24C4 Full HD 24" Curved LED Gaming Monitor - Black',
		category: "category_computers_hardware",
		subcategory: "sub_computer_peripherals",
		thumbnail: "https://media.currys.biz/i/currysprod/10202550",
		images : [
			{ id: 0, src: "https://media.currys.biz/i/currysprod/10202550" },
			{ id: 1, src: "https://media.currys.biz/i/currysprod/10202550_001" },
			{ id: 2, src: "https://media.currys.biz/i/currysprod/10202550_002" },
			{ id: 3, src: "https://media.currys.biz/i/currysprod/10202550_003" }
		],
		seller: {
			id: "storex",
			created: 1658869640,
			username: "Storex",
			avatar: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/strx.png",
			rating: 4.5,
			listings: [
				{ id: "64O30C1G60O30C1H", title: "Professional Pixel Camera", thumbnail: "https://d-themes.com/wordpress/wolmart/demo-1/wp-content/uploads/sites/4/2021/03/professional-pixel-camera-2.jpg", reviews: { rating: 5, count: 1, topRated: "Good Price" }, price: "219.99" },
				{ id: "64O30C1G60O30C1H", title: "Professional Pixel Camera", thumbnail: "https://d-themes.com/wordpress/wolmart/demo-1/wp-content/uploads/sites/4/2021/03/professional-pixel-camera-2.jpg", reviews: { rating: 5, count: 1, topRated: "Good Price" }, price: "219.99" },
				{ id: "64O30C1G60O30C1H", title: "Professional Pixel Camera", thumbnail: "https://d-themes.com/wordpress/wolmart/demo-1/wp-content/uploads/sites/4/2021/03/professional-pixel-camera-2.jpg", reviews: { rating: 5, count: 1, topRated: "Good Price" }, price: "219.99" }
			]
		},
		location: "GB",
		price: "169.99",
		postage: {
			location: "GB",
			domestic: {
				available: dummyData2,
				service: "Royal Mail Tracked 24",
				estimate: "1-2 days"
			},
			international: {
				available: dummyData,
				service: "Parcelforce Global Value",
				estimate: "5-7 days"
			}
		},
		stock: 5,
		options: [
			{ id: 0, name: "Screen Size" }
		],
		variations: [
			// { id: -1, stock: 3, price: "1399.99" },
			{ id: 0, option0: "24 inch", stock: 5, price: "169.99" },
			{ id: 1, option0: "27 inch", stock: 5, price: "179.99" },
		],
		currencies: [
			{ name: "USDC", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/usdc.png" },
			{ name: "STRX", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/strx.png" },
			{ name: "XPR", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/xpr.png" },
			{ name: "BTC", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/xbtc.png" },
			{ name: "ETH", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/xeth.png" },
			{ name: "BNB", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/xbnb.png" }
		],
		expires: 1660830829,
		reviews: {
			rating: 4.8,
			count: 3,
			topRated: "Good Quality"
		},
		description: "Enjoy fluid, stutter-free gaming with the MSI Optix G24C4 Full HD 24 inch Curved LED Gaming Monitor. Its VA LED panel has a 144 Hz refresh rate, so it's perfect for racing, sports games and first-person shooters.<br/><br/>The 1 ms response time eliminates choppy frame rates, so even the most visually demanding games flow smoothly. And built-in AMD FreeSync means your monitor will automatically sync with your graphics card. So, your game looks great, with no lag, screen tearing or stuttering.<br/><br/>Immerse yourself in the action with the Full HD 24 inch screen. Its curved design brings your game to life, with almost no frame round the edges. You can even put 2 monitors together for a truly absorbing set-up.<br><br/>Plus, long gaming sessions will be easier on your eyes. The G24C4 produces less blue light and comes with anti-flicker technology, so you can play for longer with less eye fatigue.",
		stats: {
			sales: 2,
			impressions: 137,
			clicks: 24
		}
	},
	"64O30C1G60O30C1J": {
		_id: "64O30C1G60O30C1J",
		title: 'RAZER Viper 8K Optical Gaming Mouse',
		category: "category_computers_hardware",
		subcategory: "sub_computer_peripherals",
		thumbnail: "https://media.currys.biz/i/currysprod/10220324",
		images : [
			{ id: 0, src: "https://media.currys.biz/i/currysprod/10220324" },
			{ id: 1, src: "https://media.currys.biz/i/currysprod/10220324_001" },
			{ id: 2, src: "https://media.currys.biz/i/currysprod/10220324_002" },
			{ id: 3, src: "https://media.currys.biz/i/currysprod/10220324_003" }
		],
		seller: {
			id: "storex",
			created: 1658869640,
			username: "Storex",
			avatar: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/strx.png",
			rating: 4.5,
			listings: [
				{ id: "64O30C1G60O30C1H", title: "PCSPECIALIST Vortex ST-S Gaming PC - Intel Core i7 - RTX 3070 - 1TB HDD & 512GB SSD", thumbnail: "https://media.currys.biz/i/currysprod/10222262", reviews: { rating: 5, count: 1, topRated: "Good Price" }, price: "1399.99" },
				{ id: "64O30C1G60O30C1H", title: "MSI Optix G24C4 Full HD 24 inch Curved LED Gaming Monitor - Black", thumbnail: "https://media.currys.biz/i/currysprod/10202550", reviews: { rating: 5, count: 1, topRated: "Good Price" }, price: "169.99" },
				{ id: "64O30C1G60O30C1H", title: "RAZER Viper 8K Optical Gaming Mouse", thumbnail: "https://media.currys.biz/i/currysprod/10220324", reviews: { rating: 5, count: 1, topRated: "Good Price" }, price: "39.99" }
			]
		},
		location: "GB",
		price: "39.99",
		postage: {
			location: "GB",
			domestic: {
				available: dummyData2,
				service: "Royal Mail Tracked 24",
				estimate: "1-2 days"
			},
			international: {
				available: dummyData,
				service: "Parcelforce Global Value",
				estimate: "5-7 days"
			}
		},
		stock: 5,
		options: [
			// { id: 0, name: "Screen Size" }
		],
		variations: [
			{ id: -1, stock: 2, price: "39.99" },
			// { id: 0, option0: "24 inch", stock: 5, price: "169.99" },
			// { id: 1, option0: "27 inch", stock: 5, price: "179.99" },
		],
		currencies: [
			{ name: "USDC", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/usdc.png" },
			{ name: "STRX", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/strx.png" },
			{ name: "XPR", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/xpr.png" },
			{ name: "BTC", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/xbtc.png" },
			{ name: "ETH", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/xeth.png" },
			{ name: "BNB", logo: "https://bloks.io/cdn-cgi/image/width=100,height=100/https://raw.githubusercontent.com/eoscafe/eos-airdrops/master/logos/xbnb.png" }
		],
		expires: 1660830829,
		reviews: {
			rating: 4.8,
			count: 3,
			topRated: "Good Quality"
		},
		description: "Say goodbye to response delay with the Razer Viper 8K Optical Gaming Mouse. The 8000 Hz polling rate means this deadly serpent communicates with your PC 8000 times each second, effectively getting rid of response time in your clicks and moves. Complemented by a 20K DPI sensor and optical switches, you get extremely fast and precise gaming weapon. To keep up on the outside too, the Viper 8K has a super-flexible braided cable and Teflon feet.",
		stats: {
			sales: 2,
			impressions: 137,
			clicks: 24
		}
	}
};

export const dummyBestSellers = [];

export const dummyFilterData = {
	featured: [
		{ id: "64O30C1G60O30C1H", title: "Professional Pixel Camera", thumbnail: "https://d-themes.com/wordpress/wolmart/demo-1/wp-content/uploads/sites/4/2021/03/professional-pixel-camera-2.jpg", reviews: { rating: 5, count: 1, topRated: "Good Price" }, price: "219.99" },
		{ id: "64O30C1G60O30C1H", title: "Professional Pixel Camera", thumbnail: "https://d-themes.com/wordpress/wolmart/demo-1/wp-content/uploads/sites/4/2021/03/professional-pixel-camera-2.jpg", reviews: { rating: 5, count: 1, topRated: "Good Price" }, price: "219.99" },
		{ id: "64O30C1G60O30C1H", title: "Professional Pixel Camera", thumbnail: "https://d-themes.com/wordpress/wolmart/demo-1/wp-content/uploads/sites/4/2021/03/professional-pixel-camera-2.jpg", reviews: { rating: 5, count: 1, topRated: "Good Price" }, price: "219.99" },
		{ id: "64O30C1G60O30C1H", title: "Professional Pixel Camera", thumbnail: "https://d-themes.com/wordpress/wolmart/demo-1/wp-content/uploads/sites/4/2021/03/professional-pixel-camera-2.jpg", reviews: { rating: 5, count: 1, topRated: "Good Price" }, price: "219.99" },
		{ id: "64O30C1G60O30C1H", title: "Professional Pixel Camera", thumbnail: "https://d-themes.com/wordpress/wolmart/demo-1/wp-content/uploads/sites/4/2021/03/professional-pixel-camera-2.jpg", reviews: { rating: 5, count: 1, topRated: "Good Price" }, price: "219.99" }
	],
	newlyListed: [

	],
	bestSellers: [

	],
	trending: [

	]
};

export const dummyCategoryListings1 = [
	{ id: "", title: "", thumbnail: "", reviews: { rating: 5, count: 1, topRated: "Good Price" }, price: "0" },
	{ id: "", title: "", thumbnail: "", reviews: { rating: 5, count: 1, topRated: "Good Price" }, price: "0" },
	{ id: "", title: "", thumbnail: "", reviews: { rating: 5, count: 1, topRated: "Good Price" }, price: "0" },
	{ id: "", title: "", thumbnail: "", reviews: { rating: 5, count: 1, topRated: "Good Price" }, price: "0" },
	{ id: "", title: "", thumbnail: "", reviews: { rating: 5, count: 1, topRated: "Good Price" }, price: "0" },
	{ id: "", title: "", thumbnail: "", reviews: { rating: 5, count: 1, topRated: "Good Price" }, price: "0" },
	{ id: "", title: "", thumbnail: "", reviews: { rating: 5, count: 1, topRated: "Good Price" }, price: "0" },
	{ id: "", title: "", thumbnail: "", reviews: { rating: 5, count: 1, topRated: "Good Price" }, price: "0" },
];

export const dummyRecentlyViewed = [];

// export const dummyData = { "BE": "0", "CA": "0", "FR": "0", "DE": "0", "NL": "0", "PL": "0", "ES": "0", "GB": "238.47", "US": "0" }